import type { ReactNode } from "react";

export type AppPage =
  | "dashboard"
  | "search"
  | "home"
  | "blocks"
  | "history"
  | "settings";

const NAV_ITEMS: ReadonlyArray<{ page: AppPage; icon: string; label: string }> = [
  { page: "dashboard", icon: "⌂", label: "Tổng quan" },
  { page: "search", icon: "⌕", label: "Tìm YouTube" },
  { page: "home", icon: "▦", label: "Home Content" },
  { page: "blocks", icon: "⊘", label: "Nội dung chặn" },
  { page: "history", icon: "◷", label: "Lịch sử" },
  { page: "settings", icon: "⚙", label: "Thiết bị" },
];

interface AppShellProps {
  page: AppPage;
  email: string;
  busy: boolean;
  children: ReactNode;
  onNavigate: (page: AppPage) => void;
  onLogout: () => void;
}

export function AppShell({
  page,
  email,
  busy,
  children,
  onNavigate,
  onLogout,
}: AppShellProps) {
  return (
    <div className="app-shell">
      <aside className="app-sidebar" aria-label="Điều hướng chính">
        <button
          type="button"
          className="brand-button"
          onClick={() => onNavigate("dashboard")}
          aria-label="KidTube Parent – về Tổng quan"
        >
          <span className="brand-mark" aria-hidden="true">▶</span>
          <span>
            <strong>KidTube</strong>
            <small>Parent</small>
          </span>
        </button>

        <nav className="desktop-nav">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.page}
              type="button"
              className={page === item.page ? "nav-button active" : "nav-button"}
              aria-current={page === item.page ? "page" : undefined}
              onClick={() => onNavigate(item.page)}
            >
              <span aria-hidden="true">{item.icon}</span>
              {item.label}
            </button>
          ))}
        </nav>

        <div className="sidebar-account">
          <span className="account-avatar" aria-hidden="true">P</span>
          <span className="account-copy">
            <strong>Parent</strong>
            <small title={email}>{email}</small>
          </span>
          <button type="button" className="icon-button" onClick={onLogout} disabled={busy} title="Đăng xuất">
            ↪
          </button>
        </div>
      </aside>

      <main className="app-main">{children}</main>

      <nav className="mobile-nav" aria-label="Điều hướng chính">
        {NAV_ITEMS.map((item) => (
          <button
            key={item.page}
            type="button"
            className={page === item.page ? "active" : ""}
            aria-current={page === item.page ? "page" : undefined}
            onClick={() => onNavigate(item.page)}
          >
            <span aria-hidden="true">{item.icon}</span>
            <small>{item.label.replace(" Content", "")}</small>
          </button>
        ))}
      </nav>
    </div>
  );
}
